import IntegrationWizard from '../src/containers/IntegrationWizard'

export default IntegrationWizard
